import { useState } from "react";
import SearchBar from "../../../../../components/searchBar";
import { InstrumentAmountDTO, InstrumentAmountDTOInstrumentEnum } from "../../../../../openapi-generated-client";
import { removeAllOccurances } from "../../../../../utils/arrayUtils";
import { MAX_INSTRUMENTS_SHOWN } from "../editPieceInstrumentation";
import EditPieceInstrumentElement from "./editPieceInstrumentElement";
import EditPieceSearchInstrumentElement from "./editPieceSearchInstrumentElement";

interface EditPieceInstrumentationListProps {
    instruments: Array<InstrumentAmountDTO>;
    setInstruments: (instruments: Array<InstrumentAmountDTO>) => void;
    canRemoveAccordion?: boolean;
}

export default function EditPieceInstrumentationList(props: EditPieceInstrumentationListProps) {
    
    return <div className="element-list">
            {props.instruments.map((e, i) => {
                return <EditPieceInstrumentElement notRemoveable={e.instrument == InstrumentAmountDTOInstrumentEnum.Accordion && !props.canRemoveAccordion} onDelete={() => {
                    props.setInstruments(removeAllOccurances(props.instruments, e));
                }} instrument={e.instrument} amount={e.amount} setAmount={(v: number) => {
                    if(v < 1) {
                        //Remove instrument
                        props.setInstruments(removeAllOccurances(props.instruments, e));
                        return;
                    }
                    const newInstruments = [...props.instruments];
                    newInstruments.find(instrument => instrument.instrument == e.instrument)!.amount = v
                    props.setInstruments(newInstruments);
                }}/>;
            })}
        </div>;
}